/**
 * Statusy paczek dokumentów
 *
 * @export
 * @enum {number}
 */
export enum PackStatus {
  SENT = 'SENT',
  RECEIVED = 'RECEIVED'
}

export const PackStatusTranslation = {
  [PackStatus.SENT]: 'Do odebrania',
  [PackStatus.RECEIVED]: 'Odebrana'
};
